document.addEventListener("DOMContentLoaded", function () {
  let uwlNotif = setInterval(() => {
    const notificationElement = document.querySelector(".uwl-notification");
    if (notificationElement) {
      const currentLang = document.documentElement.lang || "de";

      let notification = {
        de: {
          notif_cta: "Zur Merkliste",
          notif_heading: "Produkt zur Merkliste hinzugefügt",
        },
        fr: {
          notif_cta: "Mes favoris",
          notif_heading: "Ajouté à mes favoris",
        },
      };

      const titleElement = notificationElement.querySelector(
        ".uwl-notification-title"
      );
      const buttonElement = notificationElement.querySelector(
        ".uwl-notification-wishlist-btn"
      );

      if (titleElement && buttonElement) {
        const lang = currentLang.startsWith("fr") ? "fr" : "de";
        titleElement.textContent = notification[lang].notif_heading;
        buttonElement.textContent = notification[lang].notif_cta;
      }

      clearInterval(uwlNotif);
    }
  }, 150);
});
